import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "icon-container" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "text-container" };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = { class: "subtitle" };
const _hoisted_6 = { class: "arrow-container" };
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGNavPanel',
    props: {
        title: {},
        subtitle: {},
        icon: {},
        background: {},
        backgroundColour: {}
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "fcecc5e4": (_unref(backgroundColour))
        }));
        const props = __props;
        const emit = __emit;
        const backgroundColour = props.backgroundColour ?? '#413655';
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "nav-panel",
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: _ctx.icon ?? require('@/assets/transparent.png'),
                        class: "icon"
                    }, null, 8, _hoisted_2)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                        src: require('@/assets/arrow-right.png'),
                        alt: "Navigate",
                        class: "arrow"
                    }, null, 8, _hoisted_7)
                ]),
                (_ctx.background)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.background,
                        class: "background"
                    }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
